import React, { useState } from 'react';
import { Sparkles, AlertTriangle, Check } from 'lucide-react';
type Props = {
  issue: string;
  fieldLabel: string;
  initialValue: string;
};
export function AnomalyCard({
  issue,
  fieldLabel,
  initialValue
}: Props) {
  const [value, setValue] = useState(initialValue);
  const [resolved, setResolved] = useState(false);
  if (resolved) {
    return <div className="rounded-xl border border-[#D4FF3A]/30 bg-[#D4FF3A]/5 p-5 flex items-start gap-3" data-id="element-62">
        <div className="h-9 w-9 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] flex items-center justify-center shrink-0" data-id="element-63">
          <Check className="h-4 w-4" strokeWidth={2.5} data-id="element-64" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-65">
          <div className="text-sm font-semibold text-[#FAFAFA] font-heading" data-id="element-66">
            Anomalia risolta
          </div>
          <div className="text-xs text-[#9A9A9A] mt-1" data-id="element-67">
            Aisac ha aggiornato i dati di consegna. La spedizione riprenderà a
            breve.
          </div>
          <div className="mt-2 text-xs font-mono text-[#FAFAFA] bg-[#0A0A0A] border border-[#262626] rounded-md px-2.5 py-1.5 inline-block" data-id="element-68">
            {value}
          </div>
        </div>
      </div>;
  }
  return <div className="relative rounded-xl border border-[#EF4444]/30 bg-gradient-to-br from-[#181818] to-[#1a1410] p-5 overflow-hidden" data-id="element-69">
      {/* AI shimmer accent */}
      <div className="absolute top-0 right-0 h-px w-32 bg-gradient-to-r from-transparent via-[#D4FF3A]/40 to-transparent" data-id="element-70" />

      <div className="flex items-start gap-3 mb-4" data-id="element-71">
        <div className="h-9 w-9 rounded-lg bg-[#EF4444]/10 border border-[#EF4444]/30 text-[#EF4444] flex items-center justify-center shrink-0" data-id="element-72">
          <AlertTriangle className="h-[18px] w-[18px]" strokeWidth={2} data-id="element-73" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-74">
          <div className="flex items-center gap-2 flex-wrap" data-id="element-75">
            <span className="text-sm font-semibold text-[#FAFAFA] font-heading" data-id="element-76">
              Anomalia rilevata
            </span>
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-[#D4FF3A]/10 border border-[#D4FF3A]/30" data-id="element-77">
              <Sparkles className="h-3 w-3 text-[#D4FF3A]" strokeWidth={2.5} data-id="element-78" />
              <span className="text-[10px] font-medium text-[#D4FF3A]" data-id="element-79">
                Aisac AI
              </span>
            </span>
          </div>
          <p className="text-xs text-[#9A9A9A] mt-1.5 leading-relaxed" data-id="element-80">
            {issue}
          </p>
        </div>
      </div>

      <form onSubmit={e => {
      e.preventDefault();
      if (value.trim()) setResolved(true);
    }} className="space-y-2" data-id="element-81">
        <label className="text-[10px] text-[#6B6B6B] font-medium" data-id="element-82">
          {fieldLabel}
        </label>
        <div className="flex gap-2 flex-wrap sm:flex-nowrap" data-id="element-83">
          <input type="text" value={value} onChange={e => setValue(e.target.value)} className="flex-1 min-w-0 px-3 py-2.5 rounded-lg bg-[#0A0A0A] border border-[#262626] text-sm text-[#FAFAFA] placeholder:text-[#6B6B6B] focus:outline-none focus:ring-2 focus:ring-[#D4FF3A]/30 focus:border-[#333] font-mono" placeholder="Inserisci il dato corretto" data-id="element-84" />
          <button type="submit" className="px-4 py-2.5 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] text-sm font-semibold hover:bg-[#c2ed28] focus:outline-none focus:ring-2 focus:ring-[#D4FF3A]/40 transition shrink-0" data-id="element-85">
            Conferma e sblocca
          </button>
        </div>
        <p className="text-[11px] text-[#6B6B6B] flex items-center gap-1.5" data-id="element-86">
          <Sparkles className="h-3 w-3 text-[#D4FF3A]/70" data-id="element-87" />
          Aisac validerà l'aggiornamento e notificherà il vettore in automatico.
        </p>
      </form>
    </div>;
}